module.exports = __webpack_public_path__ + "img/pinup.87d1e1cd.svg";